import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Chart from "react-apexcharts";
import { Stack, Typography } from '@mui/material';
import { t } from 'i18next';
import ReactECharts from "echarts-for-react";


function EfficiencyChart(props) {

    const { data, timeAggType } = props;

    const { t } = useTranslation();


    let options = data.map(genData => {

        let series = [];
        series.push({
            name: t("Electrical efficiency"),
            data: genData.electrical_efficiency,
            type:'line',
            symbol: 'none',
            lineStyle: {
                width: 4
            }
        })

        series.push({
            name: t("Thermal efficiency"),
            data: genData.thermal_efficiency,
            type:'line',
            symbol: 'none',
            lineStyle: {
                width: 4
            }
        })

        return ({
            tooltip: {
                trigger: "axis",
                valueFormatter: (value) =>
                    typeof value == "number" ? (value*100.0).toLocaleString(navigator.language,{
                        minimumFractionDigits:2,
                        maximumFractionDigits:2
                    }) + " %" : value,
            },
            grid: {
                top: '4%',
                containLabel: true,
                left: '4%',
                right: '5%',
                bottom: 25
                
            },
            legend: {
                show: true,
                bottom: 0, 
                left: "center",
                symbol: 'none'
            },
            xAxis: {
                type: 'category',
                data: genData.timestamps.map(
                    (item) => timeAggType !== "q"? item : (item.replace("Q1", "-01-01").replace("Q2", "-04-01").replace("Q3", "-07-01").replace("Q4", "-10-01"))
                ),
                silent: false,
            },
            yAxis: {
                splitArea: {
                    show: false,
                },
            },
            textStyle: {
                fontFamily: "Roboto, Helvetica, Arial, sans-serif" 
            },
            series: series,
        });

    });


    return (
        <Stack>{
            options.map((opt, i) => 
                <div key={data[i].generator_name}>
                    <Typography paddingTop={'25px'} align="center" component="h2" variant="h6" color="primary" gutterBottom>{t("Efficiency") + ` (${data[i].generator_name})`}</Typography>
                    <ReactECharts option={opt}/> 
                </div>
            )           
        }</Stack>
        
    )

};

export default EfficiencyChart;
